import { useAuthContext } from '../../auth/context';
import {
  MutationOptions as BaseMutationOptions,
  useBaseAuthenticatedMutation,
} from './use-base-authenticated-mutation';

export type MutationOptions<TData = unknown, TPayload = unknown> = Omit<
  BaseMutationOptions<TData, TPayload>,
  'retrieveAccessToken'
>;

export function useAuthenticatedMutation<TData, TPayload>({
  url,
  options,
  method,
  bodyType,
  language,
}: MutationOptions<TData, TPayload>) {
  const { retrieveAccessToken } = useAuthContext();

  return useBaseAuthenticatedMutation({ url, options, method, bodyType, language, retrieveAccessToken });
}
